<template>
  <div class="head">
    <!--  左边logo  -->
    <div class="head_left">
      <img
        class="head_left_logo"
        referrerpolicy="no-referrer"
        src="./../assets/image/head_left_logo.png"
        @click="backToHome()"
      />
    </div>

    <!--  右边行为  -->
    <div class="head_right">
      <el-dropdown class="select_software">
        <span class="select_software_span">{{ languageContent }} </span>
        <el-dropdown-menu slot="dropdown" :append-to-body="false">
          <el-dropdown-item @click.native="changeLangauge('1')">
            <span style="display: block">简体中文</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLangauge('2')">
            <span style="display: block">繁体中文</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLangauge('3')">
            <span style="display: block">English</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLangauge('4')">
            <span style="display: block">Bahasa indonesia</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLangauge('5')">
            <span style="display: block">にほんご</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLangauge('6')">
            <span style="display: block">한국어</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="head_right_cart" @click="selectMenuValue(1, role)"></div>

      <div class="head_right_user" @click="selectMenuValue(2, role)"></div>
    </div>

    <!-- 首页登陆 -->
    <el-dialog
      :title="$t('用户登录')"
      :visible.sync="homeLoginVisible"
      @close="homeLoginDialogClosed"
      :append-to-body="true"
      class="homeLoginClass"
    >
      <el-form
        :model="homeLoginForm"
        :rules="homeLoginFormRules"
        ref="homeLoginForm"
        label-width=""
        class="homeLoginClassForm"
      >
        <el-form-item prop="email">
          <div>
            <el-input
              v-model="homeLoginForm.email"
              :placeholder="$t('邮箱')"
              clearable
            >
              <i slot="prefix">
                <img
                  class="home_login_email"
                  src="./../assets/image/home_login_email.png"
                  alt=""
                />
              </i>
            </el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="homeLoginForm.password"
            show-password
            :placeholder="$t('密码')"
            clearable
          >
            <i slot="prefix">
              <img
                class="home_login_pwd"
                src="./../assets/image/home_login_pwd.png"
                alt=""
              />
            </i>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            @click="submitHomeLogin(homeLoginForm)"
            class="homeLogin_loginButton"
            >{{ $t('登录') }}</el-button
          >
          <div class="homeLogin_bottomButton_all">
            <el-button
              class="homeLogin_bottomButton_left"
              @click="register()"
              >{{ $t('前往注册') }}</el-button
            >
            <el-button class="homeLogin_bottomButton_right" @click="forget()">{{
              $t('忘记密码')
            }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 忘记密码 -->
    <el-dialog
      :title="$t('忘记密码')"
      :visible.sync="forgetVisible"
      @close="forgetDialogClosed"
      :append-to-body="true"
      class="forgetClass"
    >
      <el-form
        :model="forgetForm"
        :rules="forgetFormRules"
        ref="forgetForm"
        label-width=""
        class="forgetClassForm"
      >
        <el-form-item prop="email">
          <div>
            <el-input
              v-model="forgetForm.email"
              :placeholder="$t('邮箱')"
              clearable
            >
              <i slot="prefix">
                <img
                  class="home_login_email"
                  src="./../assets/image/home_login_email.png"
                  alt=""
                />
              </i>
            </el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="forgetForm.password"
            show-password
            :placeholder="$t('密码')"
            clearable
          >
            <i slot="prefix">
              <img
                class="home_login_pwd"
                src="./../assets/image/home_login_pwd.png"
                alt=""
              />
            </i>
          </el-input>
        </el-form-item>

        <el-form-item prop="password2">
          <el-input
            v-model="forgetForm.password2"
            show-password
            :placeholder="$t('确认密码')"
            clearable
          >
            <i slot="prefix">
              <img
                class="home_login_pwd"
                src="./../assets/image/home_login_pwd.png"
                alt=""
              />
            </i>
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <el-input v-model="forgetForm.code" :placeholder="$t('验证码')">
            <i slot="prefix">
              <img
                class="higgs_register_code"
                src="./../assets/image/higgs_register_code.png"
                alt=""
              />
            </i>
            <el-button
              type="text"
              slot="suffix"
              class="forgetForm_send_code"
              v-if="!sendMsgDisabled"
              @click="getCode()"
              >{{ $t('发送验证码') }}</el-button
            >
            <el-button
              type="text"
              slot="suffix"
              class="forgetForm_send_code"
              v-if="sendMsgDisabled"
              >{{ time + 's' }}</el-button
            >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            @click="submitForget(forgetForm)"
            class="forgetForm_button"
            >{{ $t('确认') }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 修改密码成功 -->
    <el-dialog
      :visible.sync="editPwdSuccessVisible"
      :modal="false"
      @close="forgetDialogClosed"
      :show-close="false"
      :append-to-body="true"
      class="registerSuccess"
    >
      <div class="registerSuccess_div">
        <div class="registerSuccess_text">
          {{ $t('密码修改成功！请重新登录') }}
        </div>
        <el-button
          @click="editPwdSuccessVisible = false"
          class="registerSuccess_button"
          >{{ $t('确定') }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 是否退出登录 -->
    <el-dialog
      :visible.sync="isLoginOutVisible"
      :modal="false"
      @close="isLoginOutVisible = false"
      :show-close="false"
      :append-to-body="true"
      class="registerSuccess"
    >
      <div class="registerSuccess_div">
        <div class="registerSuccess_text">{{ $t('是否退出登录？') }}</div>
        <el-button
          @click="isLoginOutVisible = false"
          class="registerSuccess_button_1"
          >{{ $t('取 消') }}</el-button
        >
        <el-button @click="logOut()" class="registerSuccess_button_2">{{
          $t('确 定')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from './../store'
export default {
  // inject: ['reload'],
  data() {
    // 邮箱验证
    const checkEmail = (rule, value, cb) => {
      // 验证邮箱的正则表达式
      //  const regEmail = /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/;
      const regEmail =
        /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (regEmail.test(value)) {
        return cb()
      }

      cb(new Error(this.$t('请您输入正确的邮箱格式！')))
    }
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      // var reg = new RegExp('^(?!_)(?!.*?_$)[a-zA-Z0-9_]+$');
      // var reg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,18}');
      let reg =
        /^(?=.*[0-9].*)(?=.*[A-Z].*)|(?=.*[0-9].*)(?=.*[a-z].*)|(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/
      let reg1 = /[\u4E00-\u9FA5\uF900-\uFA2D]/
      if (!reg1.test(value)) {
        if (value.length < 6) {
          return callback(new Error(this.$t('密码不能少于6位!')))
        } else if (value.length > 18) {
          return callback(new Error(this.$t('密码不能超过18个字符!')))
        } else if (!reg.test(value)) {
          return callback(
            new Error(this.$t('密码必须包含至少2种数字、字母和符号!'))
          )
        } else {
          callback()
        }
      } else {
        return callback(
          new Error(this.$t('密码必须包含至少2种数字、字母和符号!'))
        )
      }
    }
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error(this.$t('重复密码不能为空！')))
      } else if (this.forgetForm.password != this.forgetForm.password2) {
        return callback(new Error(this.$t('两个密码不一致!')))
      } else {
        callback()
      }
    }

    return {
      time: 60, // 发送验证码倒计时
      sendMsgDisabled: false,
      // 菜单图片
      imgList: [
        {
          tp: require('./../assets/image/head_right_user_checked_bg.png'),
          tp1: require('./../assets/image/head_right_cart.png'),
          show: false,
          value: 1,
        },
        {
          tp: require('./../assets/image/head_right_user_checked_bg.png'),
          tp1: require('./../assets/image/head_right_e-mail.png'),
          show: false,
          value: 6,
        },
        {
          tp: require('./../assets/image/head_right_user_checked_bg.png'),
          tp1: require('./../assets/image/head_right_twitter.png'),
          show: false,
          value: 7,
        },
        {
          tp: require('./../assets/image/head_right_user_checked_bg.png'),
          tp1: require('./../assets/image/head_right_user.png'),
          show: false,
          value: 2,
        },
      ],
      // 语言下拉框
      options: [
        {
          value: '1',
          label: '简体中文',
        },
        {
          value: '2',
          label: '繁体中文',
        },
        {
          value: '3',
          label: 'English',
        },
        {
          value: '4',
          label: 'Bahasa indonesia',
        },
        {
          value: '5',
          label: 'にほんご',
        },
        {
          value: '6',
          label: '한국어',
        },
      ],
      // 语言值
      value: '1',

      // 登录状态（false，未登录，true，已登录）
      homeLoginStatus: false,
      // 首页登录对话框（true，打开，false，关闭）
      homeLoginVisible: false,
      // 首页登陆表单
      homeLoginForm: {
        // 邮箱
        email: '',
        // 密码
        password: '',
        // 登录按钮开关
        // btnSwitch: true,
      },
      // homeLogin表单验证
      homeLoginFormRules: {
        // 邮箱
        email: [
          {
            required: true,
            message: this.$t('请输入您的邮箱！'),
            trigger: 'blur',
          },
          { validator: checkEmail, trigger: 'blur' },
        ],
        // 密码
        password: [
          {
            required: true,
            message: this.$t('请输入您的密码！'),
            trigger: 'blur',
          },
          { validator: pwdCheck, trigger: 'blur' },
        ],
      },

      // 忘记密码对话框（true，打开，false，关闭）
      forgetVisible: false,
      // 忘记密码表单
      forgetForm: {
        // 邮箱
        email: '',
        // 密码
        password: '',
        // 确认密码
        password2: '',
        // 验证码
        code: '',
      },
      // homeLogin表单验证
      forgetFormRules: {
        // 邮箱
        email: [
          {
            required: true,
            message: this.$t('请输入您的邮箱！'),
            trigger: 'blur',
          },
          { validator: checkEmail, trigger: 'blur' },
        ],
        // 密码
        password: [
          {
            required: true,
            message: this.$t('请输入您的密码！'),
            trigger: 'blur',
          },
          { validator: pwdCheck, trigger: 'blur' },
        ],
        // 密码
        password2: [
          {
            required: true,
            message: this.$t('请再次输入您的密码！'),
            trigger: 'blur',
          },
          { validator: pwdAgainCheck, trigger: 'blur' },
        ],
        // 验证码
        code: [
          {
            required: true,
            message: this.$t('请输入验证码！'),
            trigger: 'blur',
          },
          {
            min: 4,
            max: 6,
            message: this.$t('长度为4 ~ 6个字符'),
            trigger: 'blur',
          },
        ],
      },

      // 修改密码成功对话框（true，打开，false，关闭）
      editPwdSuccessVisible: false,
      // 语言
      languageValue: '1',
      languageContent: '',
      // token
      token: 0,
      role: 0,
      tokenAlive: true,

      // 是否登出
      isLoginOutVisible: false,
    }
  },
  methods: {
    // 图例改变
    changeIndex(index) {
      this.imgList[index].show = !this.imgList[index].show
    },
    changeIndexBack(index) {
      this.imgList[index].show = !this.imgList[index].show
    },
    // 选择菜单下拉框
    selectMenuValue(value, role) {
      // 前往我的订单
      if (value == 1 && role != 0 && role != null) {
        this.$router.push('./HIGGSMyOrder')
      }
      // 登录弹框
      else if ((value == 2 && role == null) || (value == 2 && role == 0)) {
        this.homeLoginVisible = true
      }
      // 退出登录
      else if (value == 2 && role != 0 && role != null) {
        this.isLoginOutVisible = true
      } else if (value == 6) {
        window.open('mailto:higgsweb3@gmail.com', '_blank')
      } else if (value == 7) {
        window.open('https://twitter.com/HiggsWeb3', '_blank')
      } else if ((value == 1 && role == null) || (value == 1 && role == 0)) {
        this.$message({
          message: this.$t('Please log in to your account first!'),
          type: 'warning',
          duration: 3000,
        })
      }
    },
    // 前往后端
    goToBackHome() {
      this.$router.push('./HiggsBackHome')
    },
    // 前往注册
    goToRegister() {
      this.$router.push('./HiggsRegister')
    },
    // 清除首页登录数据
    homeLoginDialogClosed() {
      this.$refs.homeLoginForm.resetFields()
    },
    // 清除忘记密码数据
    forgetDialogClosed() {
      this.$refs.forgetForm.resetFields()
    },
    // 登陆操作
    submitHomeLogin() {
      var that = this
      that.$refs.homeLoginForm.validate((valid) => {
        if (valid) {
          // 登录接口
          that
            .$http({
              url: '/User/loginByPWDNew/' + that.languageValue,
              method: 'GET',
              params: {
                name: that.homeLoginForm.email,
                pwd: that.homeLoginForm.password,
              },
              withCredentials: true,
              crossDomain: true,
              //解决跨域问题，不加无法跨域
              emulateJSON: true,
            })
            .then((response) => {
              console.log(response)

              if (response.data.state === 1) {
                // 关闭首页登录对话框
                that.homeLoginVisible = false
                // 登录状态 1
                that.$store.commit('SET_TOKEN', response.data.data.user.state)
                that.state = 1
                that.tokenAlive = false

                that.$store.commit('SET_ROLE', response.data.data.user.role)
                that.role = response.data.data.user.role

                that.$store.commit('SET_USERCODE', response.data.data.user.code)
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error',
                  duration: 3000,
                })
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 忘记密码
    submitForget() {
      var that = this
      that.$refs.forgetForm.validate((valid) => {
        if (valid) {
          // 注册接口
          that
            .$http({
              url:
                '/User/findPwd/' +
                that.languageValue +
                '?code=' +
                that.forgetForm.code +
                '&mail=' +
                that.forgetForm.email +
                '&newPwd=' +
                that.forgetForm.password,
              method: 'POST',
              withCredentials: true,
              crossDomain: true,
              //解决跨域问题，不加无法跨域
              emulateJSON: true,
            })
            .then((response) => {
              console.log(response)

              if (response.data.state === 1) {
                // 关闭忘记密码对话框
                ;(this.forgetVisible = false),
                  // 打开修改成功对话框
                  (this.editPwdSuccessVisible = true)
              } else {
                that.$message({
                  message: response.data.msg,
                  type: 'error',
                  duration: 3000,
                })
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取验证码
    getCode() {
      if (this.forgetForm.email == '') {
        this.$message({
          message: this.$t('邮箱不能为空！'),
          type: 'warning',
        })
      } else {
        // 倒计时
        const that = this
        that.sendMsgDisabled = true

        const interval = window.setInterval(function () {
          if (that.time-- <= 0) {
            that.time = 60
            that.sendMsgDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)

        // 发送邮箱验证码
        this.$http({
          url: '/User/sendMail/' + this.languageValue,
          method: 'POST',
          params: {
            type: '4',
            mail: this.forgetForm.email,
          },
          withCredentials: true,
          crossDomain: true,
          //解决跨域问题，不加无法跨域
          emulateJSON: true,
        }).then((res) => {
          console.log(res)
        })
      }
    },
    // 注册操作
    register() {
      // 关闭弹框
      this.homeLoginVisible = false
      // 跳转路径
      this.$router.push('./HiggsRegister')
    },
    // 忘记密码
    forget() {
      // 关闭弹框
      this.homeLoginVisible = false
      // 打开忘记密码
      this.forgetVisible = true
    },
    // 返回至首页
    backToHome() {
      this.$router.push('./Higgs')
    },
    // 语言选择
    changeLangauge(lang) {
      var that = this
      that.$store.commit('SET_LANGUAGE', lang)
      that.$i18n.locale = lang
      // that.showLangauge()
      window.location.reload()
    },
    showLangauge() {
      const currentLang = window.sessionStorage.getItem('language') || '1'
      switch (currentLang) {
        case '1':
          ;(this.languageValue = '1'), (this.languageContent = '简体中文')
          break
        case '2':
          ;(this.languageValue = '2'), (this.languageContent = '繁体中文')
          break
        case '3':
          this.languageValue = '3'
          this.languageContent = 'English'
          break
        case '4':
          this.languageValue = '3'
          this.languageContent = 'Bahasa indonesia'
          break
        case '5':
          this.languageValue = '5'
          this.languageContent = 'にほんご'
          break
        case '6':
          this.languageValue = '5'
          this.languageContent = '한국어'
          break
      }
    },
    // 退出登录
    logOut() {
      var that = this
      // 退出登录接口
      that
        .$http({
          url: '/User/logout/' + that.languageValue,
          method: 'POST',
          withCredentials: true,
          crossDomain: true,
          //解决跨域问题，不加无法跨域
          emulateJSON: true,
        })
        .then((response) => {
          console.log(response)

          if (response.data.state === 1) {
            // 登录状态 0
            that.$store.commit('SET_TOKEN', 0)
            that.state = 0
            that.$store.commit('SET_ROLE', 0)
            that.role = 0
            that.tokenAlive = true
            // 返回首页
            that.backToHome()
          } else {
            // this.$message({
            //     message: response.data.msg,
            //     type: 'error',
            //     duration: 3000
            // })

            // 登录状态 0
            that.$store.commit('SET_TOKEN', 0)
            that.state = 0
            that.$store.commit('SET_ROLE', 0)
            that.role = 0
            that.tokenAlive = true
            // 返回首页
            that.backToHome()
          }

          that.isLoginOutVisible = false
        })
    },
  },
  components: {},
  created() {
    var that = this
    // 语言选择
    const language = store.state.language ? store.state.language : '1'
    that.languageValue = language

    // 登录状态
    const token = store.state.token
      ? store.state.token
      : window.sessionStorage.getItem('token')
    if (token == 1) {
      that.token = 1
      that.tokenAlive = false
    } else if (token == 0) {
      that.token = 0
      that.tokenAlive = true
    }
    // 角色
    const role = store.state.token
      ? store.state.token
      : window.sessionStorage.getItem('role')
    that.role = role

    // that.showLangauge()
  },
  mounted() {},
}
</script>

<style lang="less">
.head {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: calc(100% - 16.6%);
  height: 64px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(25px);

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 8.3% 0 8.3%;

  .head_left {
    width: 160px;
    height: 34px;

    .head_left_logo {
      width: 160px;
      height: 34px;
      object-fit: contain;
      cursor: pointer;
    }
  }

  .head_right {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;

    .select_software {
      width: 36px;
      height: 37px;

      background-image: url('~@/assets/image/head_icon1.png');
      background-position: center center;
      background-size: contain;
      cursor: pointer;

      .select_software_span {
        display: block;
        width: 100% !important;
        height: 100% !important;
      }

      .el-dropdown-menu {
        top: 48px !important;
        left: unset !important;
        right: calc(8.3% + 250px) !important;
        width: 204px !important;
      }
    }
    .select_software:hover {
      background-image: url('~@/assets/image/head_icon1_hover.png');
    }

    .head_right_cart {
      width: 40px;
      height: 40px;

      background-image: url('~@/assets/image/head_icon2.png');
      background-position: center center;
      background-size: contain;
      cursor: pointer;
      margin: 0 0 0 85px;
    }
    .head_right_cart:hover {
      background-image: url('~@/assets/image/head_icon2_hover.png');
    }
    .head_right_user {
      width: 40px;
      height: 40px;

      background-image: url('~@/assets/image/head_icon3.png');
      background-position: center center;
      background-size: contain;
      cursor: pointer;

      margin: 0 0 0 85px;
    }
    .head_right_user:hover {
      background-image: url('~@/assets/image/head_icon3_hover.png');
    }
  }
}

.homeLoginClass {
  .el-dialog {
    width: 800px !important;
    background: #ffffff;
    box-shadow: 0px 17px 52px 10px rgba(4, 4, 29, 0.74);
    border-radius: 0px;

    .el-dialog__title {
      font-size: 29px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #010722;
      line-height: 40px;
    }
  }

  .homeLoginClassForm {
    .el-input {
      width: 660px;
    }
    .el-input__inner {
      width: 600px;
      height: 80px;
      background: #efefef;
      opacity: 0.7;
      border-radius: 40px;
      margin: 18px 0 0 80px;
      font-size: 25px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #727a8e;
      line-height: 40px;
    }
    .home_login_email {
      width: 36px;
      height: 36px;
      margin: 44px 0 18px 109px;
    }
    .home_login_pwd {
      width: 36px;
      height: 36px;
      margin: 44px 0 18px 109px;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 84px;
    }
    .el-input .el-input__clear {
      position: absolute;
      height: 80px;
      margin: 18px 0 0 0;
      padding: 0 0 0 0;
    }
    .el-form-item__error {
      margin: 0 0 0 80px;

      font-size: 25px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ff4444;
    }

    .homeLogin_loginButton {
      width: 600px;
      height: 80px;
      background: #2064ff;
      border-radius: 40px;

      font-size: 29px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;

      margin: 15px 0 0 80px;
    }
    .homeLogin_bottomButton_all {
      margin: 72px 60px 0 60px;
      height: 54px;
      width: 640px;

      .homeLogin_bottomButton_left {
        width: auto;
        height: 54px;
        border: 3px solid #373d53;
        border-radius: 25px;

        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #373d53;
        line-height: 25px;
      }
      .homeLogin_bottomButton_right {
        width: auto;
        height: 54px;
        border: 3px solid #373d53;
        border-radius: 25px;

        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #373d53;
        line-height: 25px;

        float: right;
      }
    }
  }
}

.forgetClass {
  .el-dialog {
    width: 800px;

    .el-dialog__header {
      .el-dialog__title {
        width: 100%;
        height: 29px;
        font-size: 29px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #010722;
        line-height: 40px;
      }
    }

    .el-dialog__body {
      .forgetClassForm {
        margin: 32px 0 0 80px;

        .el-form-item {
          margin: 0 0 31px 0;
        }

        .el-input__inner {
          width: 600px;
          height: 80px;
          background: #efefef;
          // opacity: 0.7;
          border-radius: 40px;

          font-size: 25px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #727a8e;
          line-height: 40px;

          padding: 0 150px 0 101px;
        }

        .el-input__inner::placeholder {
          color: #727a8e;
        }

        .el-input__prefix {
          margin: 23px 0 0 48px;
        }

        .el-input .el-input__clear {
          position: absolute;
          height: 80px;
          margin: 0 0 0 160px;
          padding: 0 0 0 0;
        }

        .el-form-item__error {
          font-size: 25px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #ff4444;
          line-height: 25px;
        }

        .el-form-item__content {
          width: auto;
        }
        .el-input__suffix {
          width: 200px;

          .forgetForm_send_code {
            width: 100%;
            height: 80px;
            font-size: 17px;
            font-family: Source Han Sans SC;
            font-weight: 550;
            color: #3a76ff;
            line-height: 40px;
            position: absolute;

            margin: 0 0 0 -210px;
            text-align: right;
          }
        }

        .forgetForm_button {
          width: 600px;
          height: 80px;
          background: #2064ff;
          border-radius: 40px;

          font-size: 29px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 40px;
        }
      }
    }
  }
}

.registerSuccess {
  .el-dialog {
    width: 600px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      width: 600px;
      height: 400px;
      background: #010722;
    }

    .registerSuccess_div {
      width: 600px;
      text-align: center;

      .registerSuccess_text {
        width: 100%;
        height: 40px;
        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;

        margin: 108px 0 0 0;
      }

      .registerSuccess_button {
        width: 68px;
        height: 44px;
        border: 3px solid #ffffff;
        border-radius: 10px;
        background: #010722;

        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 550;
        color: #ffffff;
        line-height: 16px;

        margin: 148px 0 0 0;
      }

      .registerSuccess_button_1 {
        width: auto;
        height: 44px;
        border: 3px solid #ffffff;
        border-radius: 10px;
        background: #010722;

        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 550;
        color: #ffffff;
        line-height: 16px;

        margin: 148px 20px 0 0;
        text-align: center;
      }

      .registerSuccess_button_2 {
        width: auto;
        height: 44px;
        border: 3px solid #ffffff;
        border-radius: 10px;
        background: #010722;

        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 550;
        color: #ffffff;
        line-height: 16px;

        margin: 148px 0 0 20px;
        text-align: center;
      }
    }
  }
}

.el-select-dropdown__item {
  font-size: 17px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  line-height: 17px;
}

@media screen and (max-width: 1080px) {
  .head {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: calc(100% - 8.3%);
    height: 44px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(25px);

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 4.15% 0 4.15%;

    .head_left {
      width: 96px;
      height: 20px;

      .head_left_logo {
        width: 96px;
        height: 20px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    .head_right {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;

      .select_software {
        width: 24px;
        height: 24px;

        background-image: url('~@/assets/image/head_icon1.png');
        background-position: center center;
        background-size: contain;
        cursor: pointer;

        .select_software_span {
          display: block;
          width: 100% !important;
          height: 100% !important;
        }

        .el-dropdown-menu {
          top: 44px !important;
          left: unset !important;
          right: calc(4.15% + 128px) !important;
          width: 204px !important;
        }
      }
      .select_software:hover {
        background-image: url('~@/assets/image/head_icon1_hover.png');
      }

      .head_right_cart {
        width: 24px;
        height: 24px;

        background-image: url('~@/assets/image/head_icon2.png');
        background-position: center center;
        background-size: contain;
        cursor: pointer;
        margin: 0 0 0 42.5px;
      }
      .head_right_cart:hover {
        background-image: url('~@/assets/image/head_icon2_hover.png');
      }
      .head_right_user {
        width: 24px;
        height: 24px;

        background-image: url('~@/assets/image/head_icon3.png');
        background-position: center center;
        background-size: contain;
        cursor: pointer;

        margin: 0 0 0 42.5px;
      }
      .head_right_user:hover {
        background-image: url('~@/assets/image/head_icon3_hover.png');
      }
    }
  }

  .el-select-dropdown__item {
    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 17px;
  }

  .homeLoginClass {
    .el-dialog {
      width: 90% !important;
      background: #ffffff;
      box-shadow: 0px 17px 52px 10px rgba(4, 4, 29, 0.74);
      border-radius: 0px;

      .el-dialog__title {
        font-size: 29px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #010722;
        line-height: 40px;
      }
    }

    .homeLoginClassForm {
      .el-input {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
        height: 60px;
        background: #efefef;
        opacity: 0.7;
        border-radius: 36px;
        margin: 0 0 0 0;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #727a8e;
      }
      .el-input__prefix {
        display: flex;
        align-items: center;
      }
      .home_login_email {
        width: 24px;
        height: 24px;
        margin: 0 0 0 5px;
        display: flex;
      }
      .home_login_pwd {
        width: 24px;
        height: 24px;
        margin: 0 0 0 5px;
        display: flex;
      }
      .el-input--prefix .el-input__inner {
        padding-left: 40px;
      }
      .el-input .el-input__clear {
        position: absolute;
        height: 60px;
        margin: 0 0 0 0;
        padding: 0 0 0 0;
      }
      .el-form-item__error {
        margin: 0 0 0 0;

        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ff4444;
      }

      .homeLogin_loginButton {
        width: 100%;
        height: 60px;
        background: #2064ff;
        border-radius: 36px;

        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #ffffff;

        margin: 15px 0 0 0;
      }
      .homeLogin_bottomButton_all {
        margin: 72px 0 0 0;
        height: 54px;
        width: 100%;

        .homeLogin_bottomButton_left {
          width: auto;
          height: 54px;
          border: 2px solid #373d53;
          border-radius: 36px;

          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #373d53;
        }
        .homeLogin_bottomButton_right {
          width: auto;
          height: 54px;
          border: 2px solid #373d53;
          border-radius: 36px;

          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #373d53;

          float: right;
        }
      }
    }
  }

  .forgetClass {
    .el-dialog {
      width: 90% !important;
      background: #ffffff;
      box-shadow: 0px 17px 52px 10px rgba(4, 4, 29, 0.74);
      border-radius: 0px;

      .el-dialog__header {
        .el-dialog__title {
          font-size: 29px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #010722;
          line-height: 40px;
        }
      }

      .el-dialog__body {
        .forgetClassForm {
          margin: 0 0 0 0;

          .el-form-item {
            margin: 0 0 22px 0;
          }

          .el-input__inner {
            width: 100%;
            height: 60px;
            background: #efefef;
            opacity: 0.7;
            border-radius: 36px;
            margin: 0 0 0 0;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #727a8e;

            padding: 0 0 0 0;
          }

          .el-input__inner::placeholder {
            color: #727a8e;
          }
          .home_login_email {
            width: 24px;
            height: 24px;
            margin: 0 0 0 5px;
            display: flex;
          }
          .home_login_pwd {
            width: 24px;
            height: 24px;
            margin: 0 0 0 5px;
            display: flex;
          }
          .higgs_register_code {
            width: 24px;
            height: 24px;
            margin: 0 0 0 5px;
            display: flex;
          }
          .el-input__prefix {
            display: flex;
            align-items: center;
            margin: 0 0 0 0;
          }
          .el-input--prefix .el-input__inner {
            padding-left: 40px;
          }
          .el-input .el-input__clear {
            position: absolute;
            height: 60px;
            margin: 0 0 0 0;
            padding: 0 0 0 0;
          }

          .el-form-item__error {
            margin: 0 0 0 0;
            line-height: 1;
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #ff4444;
          }

          .el-form-item__content {
            width: auto;
          }
          .el-input__suffix {
            width: 200px;

            .forgetForm_send_code {
              width: 100%;
              height: 60px;
              font-size: 16px;
              font-family: Source Han Sans SC;
              font-weight: 550;
              color: #3a76ff;
              position: absolute;

              margin: 0 0 0 -110px;
              text-align: right;
            }
          }

          .forgetForm_button {
            width: 100%;
            height: 60px;
            background: #2064ff;
            border-radius: 36px;

            font-size: 24px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>